// Per-user storage: routes all localStorage.* calls through the signed-in user namespace.
import { scopedStorage as localStorage } from "./userStorage";
import { emitCrmEvent } from './crmEvents';
/**
 * Local storage service for saving and retrieving prayer guides
 */

const STORAGE_KEY = 'prayer_guides';

/**
 * Save a prayer guide to local storage
 * @param {Object} guide - The prayer guide to save
 * @returns {Promise} Promise resolved when saved
 */
export const savePrayerGuide = async (guide) => {
    try {
        // Add timestamp for sorting
        const guideWithMeta = {
            ...guide,
            savedAt: new Date().toISOString()
        };

        // Get existing guides from storage
        const existingGuides = getSavedGuides();

        // Add new guide to the list
        existingGuides.push(guideWithMeta);

        // Save back to localStorage
        localStorage.setItem(STORAGE_KEY, JSON.stringify(existingGuides));

        emitCrmEvent('engagement', { kind: 'guide_saved' });

        return guideWithMeta;
    } catch (error) {
        console.error('Failed to save prayer guide:', error);
        throw new Error('Failed to save your prayer guide. Please try again.');
    }
};

/**
 * Get all saved prayer guides from local storage
 * @returns {Array} Array of saved prayer guides
 */
export const getSavedGuides = () => {
    try {
        const savedGuides = localStorage.getItem(STORAGE_KEY);
        return savedGuides ? JSON.parse(savedGuides) : [];
    } catch (error) {
        console.error('Failed to get saved guides:', error);
        return [];
    }
};

/**
 * Delete a saved prayer guide
 * @param {string} savedAt - Timestamp of the guide to delete
 * @returns {Promise} Promise resolved when deleted
 */
export const deleteSavedGuide = async (savedAt) => {
    try {
        // Get existing guides
        const existingGuides = getSavedGuides();

        // Filter out the guide to delete
        const updatedGuides = existingGuides.filter(guide => guide.savedAt !== savedAt);

        // Save back to localStorage
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedGuides));

        return true;
    } catch (error) {
        console.error('Failed to delete prayer guide:', error);
        throw new Error('Failed to delete the prayer guide. Please try again.');
    }
};

export default {
    savePrayerGuide,
    getSavedGuides,
    deleteSavedGuide
};
